// extracted by mini-css-extract-plugin
export var active = "_ea-2";
export var recordingDot = "_ea-1";
export var recordingIndicator = "_ea-0";